// Importation dynamique de toutes les images du dossier t2
const images = [
  "vanille-min.png",
  "pomme1-min.png",
  "fraise-min.png",
  "bannane-min.png",
  "poire-min.png",
  "pomme2-min.png",
  "pomme1.png",
  "fond-form-mobile.png",
  "form-right.png",
  "form-left.png",
  "fond-form.png",
  "pomme.png",
  "wait-mobile.png",
  "404-mobile.png",
  "finish-mobile.png",
  "unsejour-mobile.png",
  "trottinette-mobile.png",
  "1euro-mobile.png",
  "poire.png",
  "home-mobile.png",
  "bandeau.png",
  "form.png",
  "cta.png",
  "home.png",
  "wait.png",
  "finish.png",
  "soleil.png",
  "404.png",
  "unsejour.png",
  "1euro.png",
  "trottinette.png"
];

export function preloadImages() {
  return Promise.all(
    images.map((image) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = require(`@/assets/images/t2/${image}`);
        img.onload = resolve;
        img.onerror = reject;
      });
    })
  );
}
